import {
  endpoints,
  PreferenceLocale,
  PreferencesCaptureSnapshot,
  PreferencesProfileSnapshot,
  PreferencesSnapshotParams,
  SavePreferenceResponsesBody,
  SkipPreferenceResponsesBody,
} from '@seaters/constants';

import { api } from '../axios-instance';

const captureEndpoint = `${endpoints.preferences}/capture`;
const profileEndpoint = `${endpoints.preferences}/profile`;
const responsesEndpoint = `${endpoints.preferences}/responses`;

export const fetchPreferencesCapture = (
  params: PreferencesSnapshotParams = {}
): Promise<PreferencesCaptureSnapshot> => api.get(captureEndpoint, { params });

export const fetchPreferencesProfile = (
  params: PreferencesSnapshotParams = {}
): Promise<PreferencesProfileSnapshot> => api.get(profileEndpoint, { params });

export const savePreferenceResponses = (
  body: SavePreferenceResponsesBody,
  params: PreferencesSnapshotParams = {}
): Promise<PreferencesCaptureSnapshot> =>
  api.put(responsesEndpoint, body, { params });

export const fetchFanPreferencesAdmin = (
  fanId: string,
  params: { fanGroupId: string; locale?: PreferenceLocale }
): Promise<PreferencesProfileSnapshot> =>
  api.get(`${endpoints.fgoPreferences}/fans/${fanId}`, { params });

export const skipPreferenceResponses = (
  body: SkipPreferenceResponsesBody,
  params: PreferencesSnapshotParams = {}
): Promise<PreferencesCaptureSnapshot> =>
  api.post(`${responsesEndpoint}/skip`, body, { params });
